export default "__VITE_ASSET__CEDhesT3__"